(function () {
  'use strict';

  class CadastrarUsuarioCtrl {
    constructor($uibModalInstance, Flash, PerfisPublic, UsuariosService, uoArvore, uoSelecionada, Uos, uoArvoreNivel,
      PerfilIntegracao, PerfilAdminVeltec, Authenticator, PaisService, IdiomasEnum, MeasurementSystemEnum, RolesEnum, $translate, UsuariosMessageMap, SHARED_EMAIL_THIRD_PARTY, $scope, isNaOu,
      FeaturehubJsSdk, FeatureHubConfigKeys) {
      this.isNaOu = isNaOu;
      this.idiomasEnum = IdiomasEnum;
      this.measurementSystemEnum = MeasurementSystemEnum;
      this.isMeasurementSystemEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.MEASUREMENT_SYSTEM);
      this.rolesEnum = RolesEnum;
      this.modalInstance = $uibModalInstance;
      this.uoService = Uos;
      this.flash = Flash;
      this.perfisService = PerfisPublic;
      this.usuarioService = UsuariosService;
      this.uoArvore = uoArvore;
      this.paisService = PaisService;
      this.uoArvoreNivel = uoArvoreNivel;
      this.uosFiltradas = this.carregarUos(uoSelecionada);
      this.uoSelecionada = uoArvore.filter(uo => uo.id === uoSelecionada)[0];
      this.perfilIntegracao = PerfilIntegracao;
      this.perfilAdminVeltec = PerfilAdminVeltec;
      this.limit = 10;
      this.paises = [];
      this.EMAIL_THIRD_PARTY = SHARED_EMAIL_THIRD_PARTY;
      this.usuario = {idioma: this.idiomasEnum[0], otpEnabled: false};
      this.mapBandeiras = new Map();
      this.minCaracteres = 3;
      this.maxCaracteres = 50;
      this.scope = $scope;
      Authenticator.getUser().then(user => {
        this.user = user;
        const userLanguage = this.idiomasEnum.getIdiomaByKey(user.idioma);
        this.usuario.idioma = userLanguage || this.idiomasEnum.getIdiomaByKey('PT_BR');
        this.usuario.measurementSystem = user.measurementSystem ||
          this.measurementSystemEnum.getDefaultKeyForLanguage(this.usuario.idioma.key);
        this.carregarPaises();
        this.carregarPerfis();
      });
      this.translate = $translate;
      this.usuariosMessageMap = UsuariosMessageMap;
      this.setupLanguageWatcher();
    }

    loadMore() {
      this.limit += 10;
    }

    setupLanguageWatcher() {
      this.scope.$watch(() => this.usuario.idioma, (newLanguage, oldLanguage) => {
        if (newLanguage && newLanguage !== oldLanguage) {
          this.carregarPaises();
        }
      });
    }

    getDefaultCountryCodeForLanguage(languageKey) {
      const countryCodes = {
        'EN_US': 'US',
        'EN_GB': 'GB',
        'DE_DE': 'DE',
        'FR_FR': 'FR',
        'IT_IT': 'IT',
        'NL_NL': 'NL',
        'PL_PL': 'PL',
        'ES_ES': 'ES'
      };
      return countryCodes[languageKey] || 'BR';
    }

    carregarPaises() {
      const languageKey = this.usuario.idioma && this.usuario.idioma.key;
      this.paisService.getList({idioma: languageKey}).then(paises => {
        this.paises = paises.plain();
        this.paises.forEach(pais => {
          this.mapBandeiras.set(pais.code, this.getLinkImgBandeira(pais.code));
        });
        const defaultCountry = this.paises.find(pais => pais.code === this.getDefaultCountryCodeForLanguage(languageKey));
        if (defaultCountry) {
          this.usuario.pais = defaultCountry;
        }
      });
    }

    carregarUos(uoSelecionada) {
      this.uoService.getFilhas(uoSelecionada).then(data => this.uosFiltradas = this.uoArvoreNivel.converterEmLista(data.plain()));
    }

    carregarPerfis() {
      this.perfisService.getList()
        .then(perfis => {
          this.perfis = perfis.plain()
            .filter(p => p.nome !== 'VDrivers')
            .filter(p => p.id !== this.perfilIntegracao || this.user.perfil.id === this.perfilAdminVeltec)
            .map(p => {
              if (this.rolesEnum.getDescricaoByDescricaoDB(p.nome)) {
                p.nome = this.translate.instant(this.rolesEnum.getDescricaoByDescricaoDB(p.nome));
              }
              return p;
            });
        });
    }

    getLinkImgBandeira(code) {
      return `https://vfleets-imagens.s3-sa-east-1.amazonaws.com/paises/${code.toLowerCase()}.png`;
    }

    errorValidarTelefone(form) {
      return this.dddError(form) ||
             this.ddiError(form) ||
             this.dddDdiError(form) ||
             this.telefoneError(form);
    }

    numeroVazio(form) {
      return form.telefone.$viewValue === '' || !form.telefone.$viewValue;
    }

    labelError(form) {
      return this.comecouEdicaoTelefone(form) &&
             (this.dddError(form) ||
              this.ddiError(form) ||
              this.telefoneError(form) ||
              this.dddDdiError(form));
    }

    dddError(form) {
      return this.dddVazio(form) &&
            (!this.ddiVazio(form) && !this.numeroVazio(form) ||
             this.numeroVazio(form) && !this.ddiVazio(form));
    }

    telefoneError(form) {
      return this.numeroVazio(form) &&
            (!this.ddiVazio(form) || !this.dddVazio(form));
    }

    ddiError(form) {
      return this.ddiVazio(form) &&
              (!this.dddVazio(form) && !this.numeroVazio(form) ||
              !this.dddVazio(form) && this.numeroVazio(form));
    }

    dddDdiError(form) {
      return this.dddVazio(form) &&
             this.ddiVazio(form) &&
             !this.numeroVazio(form);
    }

    telefoneVazio(form) {
      return (form.ddd.$viewValue === '' || !form.ddd.$viewValue) &&
        (form.paisTelefone.$viewValue === '' || !form.paisTelefone.$viewValue) &&
        (form.telefone.$viewValue === '' || !form.telefone.$viewValue);
    }

    dddVazio(form) {
      return form.ddd.$viewValue === '' || !form.ddd.$viewValue;
    }

    ddiVazio(form) {
      return form.paisTelefone.$viewValue === '' || !form.paisTelefone.$viewValue;
    }

    comecouEdicaoTelefone(form) {
      return form.telefone || form.ddd || form.paisTelefone;
    }

    responsavelError(form) {
      if (form.isResponsavelPassiveis.$dirty) {
        return form.isResponsavelPassiveis.$viewValue === '' || !form.isResponsavelPassiveis.$viewValue;
      }
      return false;
    }

    loginIsThirdParty(email) {
      const emailParts = email ? email.split('@') : [];
      if (emailParts.length < 2) {
        return false;
      }
      return this.EMAIL_THIRD_PARTY.includes(emailParts[1]) && this.perfilAdminVeltec === this.user.perfil.id;
    }

    userCanEditOU() {
      const emailMain = this.user.login ? this.user.login.split('@') : [];
      return (emailMain.length === 2 ? emailMain[1] === 'trimble.com' || emailMain[1] === 'platformscience.com' : false) && this.perfilAdminVeltec === this.user.perfil.id;
    }

    salvar() {
      const usuario = {
        id: 0,
        login: this.usuario.login,
        nome: this.usuario.nome,
        pais: this.usuario.pais,
        cargo: this.usuario.cargo,
        perfil: this.usuario.perfil,
        uo: this.uoSelecionada,
        senha: this.usuario.senha,
        idioma: this.usuario.idioma.key,
        otpEnabled: this.usuario.otpEnabled,
        isResponsavelPassiveis: this.usuario.isResponsavelPassiveis
      };
      if (this.isNaOu) {
        usuario.lastName = this.usuario.lastName;
      }
      if (this.isMeasurementSystemEnabled && this.usuario.measurementSystem) {
        usuario.measurementSystem = this.usuario.measurementSystem;
      }
      if (this.userCanEditOU() && this.loginIsThirdParty(this.usuario.login)) {
        usuario.acessoTrocaUo = this.usuario.acessoTrocaUo;
      }
      if (this.usuario.telefone) {
        usuario.ddd = this.usuario.ddd;
        usuario.telefone = this.usuario.telefone;
        usuario.paisTelefone = this.usuario.paisTelefone;
      }
      this.usuarioService.post(usuario).then(
        () => this.modalInstance.close(this.translate.instant('core-permissoes.organizacao.usuarios.popup.emailSent')),
        data => {
          const messageKey = this.usuariosMessageMap[data.data.message];
          let message = messageKey ? this.translate.instant('core-permissoes.organizacao.usuarios.popup.' + messageKey) : data.data.message;
          this.flash.create('error', message);
        }
      );
    }

    cancel() {
      this.modalInstance.dismiss('cancel');
    }

    ok(form) {
      if (form.$valid && !this.errorValidarTelefone(form)) {
        this.salvar();
      } else {
        form.uo.$setDirty();
        form.email.$setDirty();
        form.nome.$setDirty();
        if (this.isNaOu) {
          form.lastName.$setDirty();
        }
        form.perfil.$setDirty();
        form.pais.$setDirty();
        form.isResponsavelPassiveis.$setDirty();
      }
    }
  }

  angular
    .module('usuarios')
    .controller('CadastrarUsuarioCtrl', CadastrarUsuarioCtrl);
}());
